// A tank's subtype slug. Tanks made before the onboarding taxonomy have
// no subtype_slug, only the free-text type label, so the slug is guessed
// from it. One rule for the score engine and the app: the app must not
// call an old freshwater tank saltwater while the score treats it as
// freshwater.

export function guessSlugFromTypeLabel(label) {
  if (!label) return null;
  const t = String(label).toLowerCase();
  if (t.startsWith('sps')) return 'sps';
  if (t.startsWith('mixed')) return 'mixed-reef';
  if (t.startsWith('soft')) return 'soft-lps';
  if (t.startsWith('fowlr')) return 'fowlr';
  if (t.startsWith('planted (high')) return 'planted-high';
  if (t.startsWith('planted (low')) return 'planted-low';
  if (t.startsWith('community')) return 'community';
  if (t.startsWith('african cichlid')) return 'cichlid';
  if (t.startsWith('shrimp')) return 'shrimp';
  if (t.startsWith('freshwater')) return 'other-freshwater';
  if (t.startsWith('saltwater')) return 'undecided-saltwater';
  return null;
}

export function tankSubtype(tank) {
  return tank?.subtype_slug || guessSlugFromTypeLabel(tank?.type) || null;
}
